import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../utils/api';
import { STATUS } from '../../../utils/status';
import { AnalyticsPayload, GetPayload, TestAttemptsState } from '../../interfaces/interface';
import extraReducers from '../../extraReducers/testAttemptsExtraReducer';

const initialState: TestAttemptsState = {
  testAttempts: {
    count: undefined,
    results: []
  },
  error: null,
  getTestAttemptsStatus: STATUS.NOT_STARTED,
  getTestAnalysisStatus: STATUS.NOT_STARTED,
  attemptsExpertDownload: {},
  expertTestAttemptsDownload: {},
  getExpertTestAttemptsDownloadStatus: STATUS.NOT_STARTED,
  getTestAttemptsDownloadStatus: STATUS.NOT_STARTED,
  getTestAttemptsDownloadMessage: '',
  getExpertTestAttemptsDownloadMessage: '',
  testAanalysis: {
    data: []
  },
  testAttemptsExpert: {
    data: []
  },
  getExpertTestAttemptStatus: STATUS.NOT_STARTED,
};

export const getTestAttempts = createAsyncThunk(
  '/project/tasker/performance/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    const { search, page, pageSize, project_id, type, paginate, expert_id, attempt_count, attempt_status, start_date, end_date, min_score, max_score, min_percent, max_percent } = payload;
    const queryString = new URLSearchParams({
      paginate: (paginate ?? false).toString(), 
      ...(search && { search }),
      ...(page && { page: page.toString() }),
      ...(pageSize && { page_size: pageSize.toString() }),
      ...(project_id && { project_id }),
      ...(type && { type }),
      ...(expert_id && { expert_id }),
      ...(attempt_count && { attempt_count }),
      ...(attempt_status && { attempt_status }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(min_score && { min_score }),
      ...(max_score && { max_score }),
      ...(min_percent && { min_percent }),
      ...(max_percent && { max_percent })

    }).toString();
    const response = await api.get(`/project/tasker/performance?${queryString}`);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
  }
);

export const getExpertTestAttempts = createAsyncThunk(
  '/project/tasker-test-attempt-history/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    const { search, page, pageSize, project_id, type, paginate, expert_id, download } = payload;
    const queryString = new URLSearchParams({
      ...(search && { search }),
      ...(page && { page: page.toString() }),
      ...(pageSize && { page_size: pageSize.toString() }),
      ...(paginate && { paginate: paginate.toString() }),
      ...(project_id && { project_id }),
      ...(type && { type }),
      ...(expert_id && { expert_id }),
      ...(download !== undefined && { download: download.toString() }),
    }).toString();
    const response = await api.get(`/project/tasker-test-attempt-history?${queryString}`);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
  }
);

export const getTestAttemptsDownload = createAsyncThunk(
  '/project/tasker/performance/download/get',
  async (payload: GetPayload = {}, thunkAPI) => {
    const { project_id, download, export_type } = payload;
    const queryString = new URLSearchParams({
      ...(download !== undefined && { download: download.toString() }),
      ...(project_id && { project_id }),
      ...(export_type && { export_type }),
    }).toString();
    const response = await api.get(`/project/tasker/performance?${queryString}`);
    const { status, data } = response;
    if (status === 202) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
  }
);


export const getExpertTestAttemptsDownload = createAsyncThunk(
  '/project/tasker-test-attempt-history/export_raw_data/post',
  async (payload: any, thunkAPI) => {
    try {
      const response = await api.post('project/tasker-test-attempt-history/export_raw_data/', payload);
      const { status, data } = response;

      if (status === 202) {
        return data;
      } else {
        return thunkAPI.rejectWithValue({ response, data });
      }
    } catch (error: any) {
        return thunkAPI.rejectWithValue({ message: error.response.data.message });
    }
  }
);

export const getTestAnalysis = createAsyncThunk(
  '/project/test-analysis',
  async (payload: AnalyticsPayload = {}, thunkAPI) => {
    const { search, page, pageSize, sort_by, sort_order, project_id, type, start_date, end_date, vendor_id } = payload;
    const queryString = new URLSearchParams({
      ...(search && { search }),
      ...(page && { page: page.toString() }),
      ...(pageSize && { page_size: pageSize.toString() }),
      ...(sort_by && { sort_by }),
      ...(sort_order && { sort_order }),
      ...(project_id && { project_id }),
      ...(type && { type }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(vendor_id && { vendor_id }),
    }).toString();
    const response = await api.get(`/project/test-analysis?${queryString}`);
    const { status, data } = response;
    if (status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue({ response, data });
    }
  }
);

const testAttemptsExpertsSlice = createSlice({
  name: 'analyticsExpert',
  initialState,
  reducers: {
    setDownloadAttemptStatus: (state, actions) => {
      state.getTestAttemptsDownloadStatus = actions.payload
    },
    setDownloadRawAttemptStatus: (state, actions) => {
      state.getExpertTestAttemptsDownloadStatus = actions.payload
    }
  },
  extraReducers
});

export const { setDownloadAttemptStatus, setDownloadRawAttemptStatus } = testAttemptsExpertsSlice.actions
export default testAttemptsExpertsSlice.reducer;
